import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ModulesProvider } from "./context/ModulesContext";
import { ProgressProvider } from "./context/ProgressContext";
import { PurchaseProvider } from "./context/PurchaseContext";
import { Layout } from "./components/layout/Layout";
import HomePage from "./pages/HomePage";
import ModulePage from "./pages/ModulePage";
import ResourcesPage from "./pages/ResourcesPage";
import CertificatePage from "./pages/CertificatePage";
import PurchasePage from "./pages/PurchasePage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCancelPage from "./pages/PaymentCancelPage";
import AdminPage from "./pages/AdminPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import RefundPage from "./pages/RefundPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <PurchaseProvider>
            <ModulesProvider>
              <ProgressProvider>
              <Layout>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/module/:slug" element={<ModulePage />} />
                  <Route path="/resources" element={<ResourcesPage />} />
                  <Route path="/certificate" element={<CertificatePage />} />
                  <Route path="/purchase" element={<PurchasePage />} />
                  <Route path="/payment/success" element={<PaymentSuccessPage />} />
                  <Route path="/payment/cancel" element={<PaymentCancelPage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/signup" element={<SignupPage />} />
                  <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                  <Route path="/reset-password" element={<ResetPasswordPage />} />
                  <Route path="/verify-email" element={<VerifyEmailPage />} />
                  <Route path="/terms" element={<TermsPage />} />
                  <Route path="/privacy" element={<PrivacyPage />} />
                  <Route path="/refund" element={<RefundPage />} />
                  <Route path="/admin" element={<AdminPage />} />
                </Routes>
              </Layout>
              </ProgressProvider>
            </ModulesProvider>
          </PurchaseProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
